<template>
  <div>
    <div v-if="!storeState.isLoggedIn">
      <div class="flex justify-center space-y-8 w-full pt-32">
        <svg class="animate-spin -ml-1 mr-3 h-20 w-20 text-gray-100" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </div>
    <div v-else>
      <div class="pt-8 pl-8 mr-8">
        <div class="text-3xl font-extrabold text-gray-100">
          Settings
        </div>
        <div v-if="true" class="pt-8">
          <div class="font-medium leading-6 text-gray-100 text-lg">
            Notifications
          </div>
          <p class="max-w-2xl text-sm text-gray-500">
            Get notifications pushed to your preferred channel
          </p>
          <div class="py-4 sm:py-5 sm:grid sm:grid-cols-4 sm:gap-4 border-b">
            <div class="col-span-1">

            </div>
            <div class="col-span-1 text-sm font-medium text-gray-500">
              SMS
            </div>
            <div class="col-span-1 text-sm font-medium text-gray-500">
              Slack
            </div>
            <div class="col-span-1 text-sm font-medium text-gray-500">
              Email
            </div>
          </div>
          <div class="py-4 sm:py-5 sm:grid sm:grid-cols-4 sm:gap-4 border-b">
            <div class="text-sm font-medium text-gray-500">
              List Alerts (Real-time)
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.alerts.sms" :class="[storeState.settings.notifications.alerts.sms ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.alerts.sms ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.alerts.sms ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.alerts.sms ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.alerts.slack" :class="[storeState.settings.notifications.alerts.slack ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.alerts.slack ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.alerts.slack ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.alerts.slack ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.alerts.email" :class="[storeState.settings.notifications.alerts.email ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.alerts.email ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.alerts.email ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.alerts.email ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
          </div>
          <div class="py-4 sm:py-5 sm:grid sm:grid-cols-4 sm:gap-4 border-b">
            <div class="text-sm font-medium text-gray-500">
              Weekly Recap
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.weekly.sms" :class="[storeState.settings.notifications.weekly.sms ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.weekly.sms ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.weekly.sms ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.weekly.sms ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.weekly.slack" :class="[storeState.settings.notifications.weekly.slack ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.weekly.slack ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.weekly.slack ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.weekly.slack ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.weekly.email" :class="[storeState.settings.notifications.weekly.email ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.weekly.email ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.weekly.email ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.weekly.email ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
          </div>
          <div class="py-4 sm:py-5 sm:grid sm:grid-cols-4 sm:gap-4 border-b">
            <div class="text-sm font-medium text-gray-500">
              Monthly Recap
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.monthly.sms" :class="[storeState.settings.notifications.monthly.sms ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.monthly.sms ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.monthly.sms ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.monthly.sms ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.monthly.slack" :class="[storeState.settings.notifications.monthly.slack ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.monthly.slack ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.monthly.slack ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.monthly.slack ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
            <div>
              <Switch v-model="storeState.settings.notifications.monthly.email" :class="[storeState.settings.notifications.monthly.email ? 'bg-blue-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
                <span :class="[storeState.settings.notifications.monthly.email ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']">
                  <span :class="[storeState.settings.notifications.monthly.email ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                      <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span :class="[storeState.settings.notifications.monthly.email ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']" aria-hidden="true">
                    <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                      <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                  </span>
                </span>
              </Switch>
            </div>
          </div>
        </div>
        <div class="pt-8">
          <div class="font-medium leading-6 text-gray-100 text-lg">
            SMS
          </div>
          <p class="max-w-2xl text-sm text-gray-500">
            Get real-time alerts when someone on a 
              <a 
                href="https://help.twitter.com/en/using-twitter/twitter-lists"
                class="font-medium text-blue-600 hover:text-blue-500"
                target="_blank"
              >
              Twitter List
              </a> tweets.
          </p>
          <div 
            class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
          >
            <div class="col-span-6 sm:col-span-2">
              <label for="phoneNumber" class="block text-sm font-medium text-gray-100">
                Mobile #
                <Popper class="inline" hover placement="top">
                  <QuestionMarkCircleIcon class="mb-1 inline h-5 w-5 text-gray-500" aria-hidden="true" />
                  <template #content>
                    <div class="bg-gray-700 text-gray-100 px-3 py-2 rounded">The mobile number you want us to send SMS alerts to
                    </div>
                  </template>
                </Popper>
              </label>
              <input 
                v-model="storeState.settings.phoneNumber"
                ref="phoneNumber" 
                name="phoneNumber" 
                id="phoneNumber" 
                placeholder="14158675309"
                autocomplete="off" 
                class="mt-1 block w-full border text-gray-100 bg-gray-800 border-gray-900 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-100 sm:text-sm" 
              />
            </div>
            <!-- <div class="col-span-6 sm:col-span-2">
              <label for="sheetName" class="block text-sm font-medium text-gray-100">Sheet Name</label>
              <input 
                v-model="storeState.settings.sheets.sheetName"
                ref="sheetName" 
                name="sheetName" 
                id="sheetName" 
                autocomplete="off" 
                class="mt-1 block w-full border text-gray-100 bg-gray-800 border-gray-900 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-100 sm:text-sm" 
              />
            </div> -->
          </div>
        </div>
        <div class="pt-8">
          <div class="font-medium leading-6 text-gray-100 text-lg">
            Twitter
          </div>
          <p class="max-w-2xl text-sm text-gray-500">
            Get analytics on your replies to 
              <a 
                href="https://help.twitter.com/en/using-twitter/twitter-lists"
                class="font-medium text-blue-600 hover:text-blue-500"
                target="_blank"
              >
              Twitter List
              </a> tweets.
          </p>
          <div 
            class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
          >
            <div class="col-span-6 sm:col-span-2">
              <div class="flex-1">
                <div class="relative rounded-md shadow-sm">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span class="text-gray-500">
                      @
                    </span>
                  </div>
                  <input 
                    type="text" 
                    autocomplete="off" 
                    v-model="storeState.settings.twitter.handle" 
                    class="pl-7 block w-full border text-gray-100 bg-gray-800 border-gray-900 rounded-md shadow-sm py-3 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-300 placeholder-gray-700" 
                    placeholder="your_twitter_handle" 
                    @keyup="getTwitterUser(storeState.settings.twitter.handle)"
                  />
                </div>
                <div 
                  class="text-gray-700 mt-1"
                  v-if="storeState.settings.twitter.data.followers_count">
                  <span class="font-bold">{{storeState.settings.twitter.data.name}} </span>
                  <span class=""> ·</span>
                  {{formatFollowerCount(storeState.settings.twitter.data.followers_count)}} followers
                </div>
                <div 
                  class="text-gray-700"
                  v-if="storeState.settings.twitter.data.description">
                  {{storeState.settings.twitter.data.description}}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div 
              v-for="(list, index) in storeState.settings.twitter.lists"
              class="py-4 sm:py-5 sm:grid grid-cols-3 sm:grid-cols-3 sm:gap-4"
              :key="index"
            >
              <div class="col-span-2 sm:col-span-2">
                <div class="flex-1">
                  <div class="relative rounded-md shadow-sm">
                    <input 
                      type="text" 
                      autocomplete="off" 
                      v-model="list.id_str" 
                      class="block w-full border text-gray-100 bg-gray-800 border-gray-900 rounded-md shadow-sm py-3 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-300 placeholder-gray-700" 
                      placeholder="List ID" 
                      @input="getTwitterList(list.id_str, index)"
                    />
                  </div>
                  <div 
                    class="text-gray-700 mt-1"
                    v-if="list && list.name">
                    <span class="font-bold">{{list.name}} </span>
                    <span class=""> ·</span>
                    {{formatFollowerCount(list.subscriber_count)}} followers 
                    <span class=""> ·</span>
                    {{list.member_count}} members
                    <div 
                      class="text-gray-700"
                      v-if="list.description"
                    >
                      {{list.description}}
                    </div>
                  </div>
                  <div class="mt-1" v-else>
                    Get this from the List URL, e.g.  
                    <a 
                      href="https://twitter.com/i/lists/1433539932530909184"
                      class="font-medium text-blue-600 hover:text-blue-500"
                      target="_blank"
                    >this List</a>
                    has an ID of 1433539932530909184
                  </div>
                  
                </div>
              </div>
              <div 
                class="col-span-1 mt-3 font-semibold cursor-pointer text-gray-600 hover:text-gray-300"
                @click="removeList(index)"
              >
                Delete
              </div>
            </div>
            <!-- <div class="col-span-6 sm:col-span-2">
              <label for="sheetName" class="block text-sm font-medium text-gray-100">Sheet Name</label>
              <input 
                v-model="storeState.settings.sheets.sheetName"
                ref="sheetName" 
                name="sheetName" 
                id="sheetName" 
                autocomplete="off" 
                class="mt-1 block w-full border text-gray-100 bg-gray-800 border-gray-900 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-100 sm:text-sm" 
              />
            </div> -->
          </div>
          <div>
            <button 
              @click="addList"
              class="py-2 mt-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 shadow-sm hover:bg-blue-500 focus:outline-none focus:shadow-outline-blue focus:bg-blue-500 active:bg-blue-600 transition duration-150 ease-in-out"
            >
              Add List
            </button>
          </div>
          <div>
            <div 
              v-for="(search, index) in storeState.settings.twitter.searches"
              class="py-4 sm:py-5 sm:grid grid-cols-3 sm:grid-cols-3 sm:gap-4"
              :key="index"
            >
              <div class="col-span-2 sm:col-span-2">
                <div class="flex-1">
                  <div class="relative rounded-md shadow-sm">
                    <input 
                      type="text" 
                      autocomplete="off" 
                      v-model="search.q" 
                      class="block w-full border text-gray-100 bg-gray-800 border-gray-900 rounded-md shadow-sm py-3 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-300 placeholder-gray-700" 
                      placeholder="Query :: CRM for dentists lang:en -is:retweet is:verified" 
                      @input="getTwitterSearch(search.q, index)"
                    />
                  </div>
                  <!-- grow audience -podcast -youtube -is:retweet lang:en is:verified -is:retweet -is:reply -->
                  <div 
                    class="text-gray-700 mt-1"
                    v-if="false"
                  >
                  </div>
                  <div class="mt-1" v-else>
                    You can search for a keyword, filter by language (e.g. <code>lang:en</code> ), Tweet type (e.g. <code>-is:retweet</code> )
                    <a 
                      href="https://developer.twitter.com/en/docs/twitter-api/tweets/search/integrate/build-a-query#specificity"
                      class="font-medium text-blue-600 hover:text-blue-500"
                      target="_blank"
                    >Learn more about building queries here.</a>
                  </div>
                  
                </div>
              </div>
              <div 
                class="col-span-1 mt-3 font-semibold cursor-pointer text-gray-600 hover:text-gray-300"
                @click="removeList(index)"
              >
                Delete
              </div>
            </div>
            <!-- <div class="col-span-6 sm:col-span-2">
              <label for="sheetName" class="block text-sm font-medium text-gray-100">Sheet Name</label>
              <input 
                v-model="storeState.settings.sheets.sheetName"
                ref="sheetName" 
                name="sheetName" 
                id="sheetName" 
                autocomplete="off" 
                class="mt-1 block w-full border text-gray-100 bg-gray-800 border-gray-900 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-100 sm:text-sm" 
              />
            </div> -->
          </div>
          <div>
            <button 
              @click="addSearch"
              class="py-2 mt-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 shadow-sm hover:bg-blue-500 focus:outline-none focus:shadow-outline-blue focus:bg-blue-500 active:bg-blue-600 transition duration-150 ease-in-out"
            >
              Add Search
            </button>
          </div>
        </div>
        <div class="pt-8">
          <button 
            @click="saveSettings"
            class="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 shadow-sm hover:bg-blue-500 focus:outline-none focus:shadow-outline-blue focus:bg-blue-500 active:bg-blue-600 transition duration-150 ease-in-out"
          >
            Save
          </button>
        </div>
        <div class="pt-8">
          <div class="font-medium leading-6 text-gray-100 text-lg">
            Twitter
          </div>
          <p class="max-w-2xl text-sm text-gray-500">
            Authenticate with Twitter
          </p>
          <div class="pt-4">
            <button 
              @click="authTwitterStep1"
              class="flex py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 shadow-sm hover:bg-blue-500 focus:outline-none focus:shadow-outline-blue focus:bg-blue-500 active:bg-blue-600 transition duration-150 ease-in-out"
            >
              <div>
                <svg width="20" height="20" fill="currentColor" class="text-white opacity-40">
                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84">
                  </path>
                </svg>
              </div>
              <div class="ml-2">
                Add Twitter
              </div>
              
            </button>
          </div>
        </div>
      </div>
      <div class="pt-16">
        <!-- jobStatuses: {{storeState.jobStatuses}} -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable vue/no-unused-components */
import { store } from '../store.js';
import { reactive, ref } from 'vue'
// import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions, Switch } from '@headlessui/vue'
import axios from 'axios';
import * as vega from "vega";
// import embed from 'vega-embed';
// import * as embed from "vega-embed";
// embed = require('vega-embed')
import Mousetrap from 'mousetrap'
import SSF from 'ssf'
import { Grid, html } from "gridjs";
import Popper from "vue3-popper";
import { supabase } from "../supabase"
import { debounce } from "debounce";

import { 
  ArrowSmUpIcon, 
  ArrowSmDownIcon, 
  SearchIcon, 
  XIcon, 
  CheckCircleIcon,
  ExclamationCircleIcon,
  QuestionMarkCircleIcon,
  PlayIcon,
  // ChartBarIcon,
  // PresentationChartLineIcon,
  // ViewGridIcon,
  CheckIcon,
  SelectorIcon,
  } from '@heroicons/vue/solid'

import { 
  ChartBarIcon,
  ViewGridIcon,
  PresentationChartLineIcon,
  PresentationChartBarIcon,
  } from '@heroicons/vue/outline'

export default {
  name: 'Metrics',
  props: {
      msg: String
  },
  components: {
    Popper,
    SearchIcon,
    XIcon,
    CheckCircleIcon,
    ExclamationCircleIcon,
    QuestionMarkCircleIcon,
    PlayIcon,
    ChartBarIcon,
    PresentationChartLineIcon,
    PresentationChartBarIcon,
    ViewGridIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    Switch,
    CheckIcon,
    SelectorIcon,
  },
  created() {
    this.setupMousetrap()
    this.getTwitterUser = debounce(this.getTwitterUser, 100);
    this.getTwitterList = debounce(this.getTwitterList, 100);
    var yourVlSpec = {
      $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
      description: 'A simple bar chart with embedded data.',
      data: {
        values: [
          {a: 'A', b: 28},
          {a: 'B', b: 55},
          {a: 'C', b: 43},
          {a: 'D', b: 91},
          {a: 'E', b: 81},
          {a: 'F', b: 53},
          {a: 'G', b: 19},
          {a: 'H', b: 87},
          {a: 'I', b: 52}
        ]
      },
      mark: 'bar',
      encoding: {
        x: {field: 'a', type: 'ordinal'},
        y: {field: 'b', type: 'quantitative'}
      }
    };
    window.analyzeGrid = new Grid({
      sort: true,
      search: false,
      pagination: {
        limit: 20
      },
      fixedHeader: true,
      height: '400px',
      // columns: ["Name", "Email", "Phone Number"],
      data: [],
      className: {
        td: 'px-6 py-4 whitespace-nowrap text-sm text-gray-100 divide-y divide-gray-200',
        th: 'px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 tracking-wider',
        table: 'min-w-full divide-gray-200',
        tbody: 'bg-white '
      }
    })
    // window.vegaEmbed('#view', yourVlSpec);
  },
  mounted() {
    this.focusStripe()
    // this.startTyped()
  },
  data() {
      return {
        store: store,
        storeState: store.state,
        slackAuthUrl: 'https://slack.com/oauth/v2/authorize' + 
          '?client_id=2068350445268.2075584116417&scope=channels:read' + 
          ',chat:write.public,chat:write,files:write&user_scope=' +
          '&redirect_uri=https://pulse.trypaper.io/slack2',
        stripeApiKey: '',
        sheetsCreds: '',
        updatingStripeKey: false,
        analysisChanged: false,
        searchTerm: '',
        searching: true,
        running: false,
        updatingField: false,
        gotMetrics: false,
        fieldInUpdate: {},
        tableFilters: {
          active: false,
        },
        vizOptions: {
          axis: [
            { id: 1, value: 'none', label: 'None' },
            { id: 2, value: 'x', label: 'X-Axis' },
            { id: 3, value: 'y', label: 'Y-Axis' },
          ]
        },
        metricData: [],
        stats: [
          { name: 'Total Subscribers', stat: '71,897', previousStat: '70,946', change: '12%', changeType: 'increase' },
          { name: 'Avg. Open Rate', stat: '58.16%', previousStat: '56.14%', change: '2.02%', changeType: 'increase' },
          { name: 'Avg. Click Rate', stat: '24.57%', previousStat: '28.62%', change: '4.05%', changeType: 'decrease' },
        ],
        vegaConfig: {
          "view": {
            "stroke": "transparent"
          },
          "arc": {"fill": "#fff"},
          "area": {"fill": "#fff"},
          "path": {"stroke": "#fff"},
          "rect": {"fill": "#fff"},
          "shape": {"stroke": "#fff"},
          "symbol": {"stroke": "#fff"},
          "circle": {"fill": "#fff"},
          "background": "transparent",
          "padding": {"top": 10, "right": 10, "bottom": 10, "left": 10},
          "style": {
            "guide-label": {"font": "Inter, sans-serif", "fontSize": 12},
            "guide-title": {"font": "Inter, sans-serif", "fontSize": 12},
            "group-title": {"font": "Inter, sans-serif", "fontSize": 12}
          },
          "title": {
            "font": "Inter, sans-serif",
            "fontSize": 14,
            "fontWeight": "bold",
            "dy": -3,
            "anchor": "start"
          },
          "axis": {
            "gridColor": "#ccc",
            "tickColor": "#fff",
            "domain": false,
            "grid": false
          }
        },
        vegaSpec: {
          "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
          "description": "MRR by Month",
          "width": "container",
          "mark": {
            "type": "line", 
            "tooltip": false, 
            "fill": null, 
            "stroke": "#010101",
            "point": {"color": "#010101"},
            },
          "encoding": {
              "x": {
                "field": "month_dt", 
                "timeUnit": "yearmonth", 
                "title": null,
                // "axis": {"tickCount": {"interval": "month", "step": 6}}
                "axis": {
                  "values": [
                    {"year": 2019, "month": "may", "date": 1},
                    {"year": 2021, "month": "may", "date": 1}
                    ]
                  }
                },
              "y": {
                "field": "mrr", 
                "aggregate": "sum", 
                "type": "quantitative",
                "title": null
                },
              "tooltip": [
                  {"field": "month_dt", "timeUnit": "yearmonth", "title": "Date"},
                  {
                    "field": "mrr", 
                    "aggregate": "sum", 
                    "type": "quantitative",
                    "format": "$,.0f",
                    "title": "MRR"
                  }
              ]
          },
          data: {values: []},
        },
      }
  },
  computed: {
    // dbtColumns() {
    //   let allCols = []
    //   for (let index = 0; index < this.storeState.dbt.models.length; index++) {
    //     const cols = this.storeState.dbt.models[index].columns;
    //     for (let i2 = 0; i2 < cols.length; i2++) {
    //       const col = cols[i2];
    //       col.modelName = this.storeState.dbt.models[index].name
    //       col.label = this.getLabel(col)
    //       allCols.push(col)
    //     }
    //   }
    //   return allCols
    // }
  },
  methods: {
    login() {
      this.$router.push({ name: 'Login', query: { goto: 'Landing' }})
    },
    logout() {
      this.$router.push({ name: 'Logout', query: { goto: 'Landing' }})
    },
    formatFollowerCount(count) {
      if (count > 1000000) {
        return (count / 1000000).toFixed(1) + 'M'

      } else if (count > 1000) {
        return (count / 1000).toFixed(1) + 'K'
      
      } else {
        return count
      }
    },
    addList() {
      let l = {id_str: null, id: null}
      this.storeState.settings.twitter.lists.push(l)
    },
    addSearch() {
      let l = {id_str: null, id: null, q: ''}
      this.storeState.settings.twitter.searches.push(l)
    },
    removeList(index) {
      this.storeState.settings.twitter.lists.pop(index)
    },
    async getTwitterSearch(id, index) {
      console.log('getting getTwitterSearch search: ', id)
    },
    async getTwitterList(id, index) {
      console.log('getting twitter list: ', id)
      if (!id || id.length <= 10) {
        // this.storeState.settings.twitter.data = {}
        return false
      }
      // const path = `https://www.wax.run/api`
      const path = `${window.location.origin}/api`
      const d = {getTwitter: true, listId: id}
      const res = await axios.post(path, d)
      console.log('got twitter: ', res.data)
      if (res.data.ok) {
        this.storeState.settings.twitter.lists[index] = res.data.data
      } else {
        this.storeState.settings.twitter.lists[index] = {id_str: id}
      }
    },
    async authTwitterStep1() {
      // const path = `https://www.wax.run/api`
      // const path = `https://seekwellapi.ngrok.io/api/twitter`
      const path = `${window.location.origin}/api/twitter`
      const d = {step1: true}
      const res = await axios.post(path, d)
      console.log('got twitter: ', res.data)
      if (res.data.ok) {
        // this.storeState.settings.twitter.data = res.data.data
        let url = `https://api.twitter.com/oauth/authenticate?oauth_token=${res.data.token}`
        window.open(url, '_blank');
      } 
    },
    async authGoogleStep1() {
      // const path = `https://www.wax.run/api`
      // const path = `https://seekwellapi.ngrok.io/api/twitter`
      // const path = `${window.location.origin}/api/google`
      // const d = {step1: true}
      // const res = await axios.post(path, d)
      // console.log('got google: ', res.data)
      let url = `https://accounts.google.com/o/oauth2/auth?access_type=offline`
      url += `&approval_prompt=auto&client_id=`
      url += `79190931278-g3bf7bimr1dpsfve8l09s1p5l5vtd483.apps.googleusercontent.com`
      url += `&response_type=code&scope=https://www.googleapis.com/auth/spreadsheets`
      url += `&redirect_uri=http://localhost:3000/google2`
      window.open(url, '_blank')
    },
    async getTwitterUser(handle) {
      console.log('getting twitter handle: ', handle)
      if (!handle || handle.length < 1) {
        this.storeState.settings.twitter.data = {}
        return false
      }
      // this.storeState.card.details.twitter = null
      // fetch("https://api.twitter.com/1.1/users/show.json?screen_name=twitterdev", {
      //   headers: {
      //     Authorization: "Bearer <API_TOKEN>"
      //   }
      // })
      const path = `https://www.wax.run/api`
      const d = {getTwitter: true, handle: handle}
      const res = await axios.post(path, d)
      console.log('got twitter: ', res.data)
      if (res.data.ok) {
        this.storeState.settings.twitter.data = res.data.data
      } else {
        this.storeState.settings.twitter.data = {}
      }
    },
    saveSettings() {
      this.updateSettings()
      let opts = {
        primary: 'Saved settings!',
        // secondary: 'Syncs to Sheets occur hourly.',
        }
      this.showMsg(this, opts)
    },
    getLabel(column) {
      if (column.meta && column.meta.dimension && column.meta.dimension.label) {
        return column.meta.dimension.label
      }
      if (column && column.label) return column.label
      if (column.name) return column.name
      return 'no label'
    },
    viewTable(table) {
      this.$router.push({ name: 'Analyze', query: { table: table.name }})
    },
    timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);
      var interval = seconds / 31536000;
      if (interval > 1) {
        return Math.floor(interval) + " years";
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return Math.floor(interval) + " months";
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return Math.floor(interval) + " days";
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return Math.floor(interval) + " hours";
      }
      interval = seconds / 60;
      if (interval > 1) {
        return Math.floor(interval) + " minutes";
      }
      return Math.floor(seconds) + " seconds";
    },
    checkJobStatus(jobId) {
      const path = this.getApiUrl('get_job')
      let d = {
        user: this.storeState.user, 
        jobId: jobId,
        }
      axios.post(path, d)
        .then((res) => {
          console.log('got get_job: ', res.data)
          var self = this
          if (!res.data.ok) {
            setTimeout(() => self.checkJobStatus(jobId), 500);
          } else if (res.data.ok && res.data.job.status === 'running') {
            this.storeState.jobStatuses[jobId] = res.data.job
            setTimeout(() => self.checkJobStatus(jobId), 1000);
          } else {
            this.storeState.jobStatuses[jobId] = res.data.job
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    checkJobStatuses() {
      this.storeState.jobStatuses = {}
      for (let index = 0; index < this.jobIds.length; index++) {
        const jobId = this.jobIds[index];
        this.checkJobStatus(jobId)
      }
    },
    focusStripe() {
      if (!this.storeState.user.hasStripe && this.$refs.stripe_api_key) {
        this.$refs.stripe_api_key.focus()
      }
    },
    updateStripeApiKey() {
      if (this.stripeApiKey.length < 5) {
        let secondary = `
          Go to your 
          <a 
            href="https://dashboard.stripe.com/apikeys/create"
            class="font-medium text-blue-600 hover:text-blue-500"
            target="_blank"
          >
            dashboard
          </a>
          to create a key.
        `
        let opts = {
          primary: 'Invalid Stripe API key',
          secondary: secondary,
          type: 'error'
          }
        this.showMsg(this, opts)
        return
      }
      this.updatingStripeKey = true
      const path = this.getApiUrl('update_secret')
      let d = {
        user: this.storeState.user, 
        stripeApiKey: this.stripeApiKey,
        type: 'stripe'
        }
      axios.post(path, d)
        .then((res) => {
          this.updatingStripeKey = false
          console.log('got update_secret: ', res.data)
          if (res.data.ok) {
            let opts = {
              primary: 'Stripe API key successfully added!',
              secondary: 'Starting sync, this will take a few minutes.',
              }
            this.showMsg(this, opts)
            this.storeState.user.hasStripe = true
            this.jobIds = res.data.jobIds
            this.checkJobStatuses()
          } else {
            let opts = {
              primary: 'Stripe API key error.',
              secondary: res.data.error,
              type: 'error'
              }
            this.showMsg(this, opts)
          }
        })
        .catch((error) => {
          this.updatingStripeKey = false
          console.error(error)
        })
    },
    runDbt() {
      if (!this.storeState.isLoggedIn || !this.storeState.gotUserData) return
      this.runningDbt = true
      const path = this.getApiUrl('run_dbt')
      let d = {user: this.storeState.user, userData: this.storeState.userData}
      axios.post(path, d)
        .then((res) => {
          this.runningDbt = false
          console.log('got run_dbt: ', res.data)
          if (res.data.ok) {
            this.dbtLogs = res.data.dbtLogs
            this.storeState.user.hasMrrFacts = true
            this.dbtErrors = res.data.dbtErrors
            for (let index = 0; index < this.dbtLogs.length; index++) {
              const log = this.dbtLogs[index];
              let ti = this.storeState.dbt.models.findIndex(m => m.name === log.table)
              if (ti >= 0) this.storeState.dbt.models[ti].count = log.count
            }
            for (let index = 0; index < this.dbtErrors.length; index++) {
              const log = this.dbtErrors[index];
              console.error(log.message)
            }
          }
        })
        .catch((error) => {
          this.runningDbt = false
          console.error(error)
        })
    },
    updateDimensionNow(index, index2, column) {
      this.updatingField = true
      this.fieldInUpdate = column
      this.fieldInUpdate.index = index
      this.fieldInUpdate.index2 = index2
      this.fieldInUpdate.dimOrMeas = 'dimension'
      let label = this.getDimensionLabel(column)
      if (this.storeState.analysis.viz.encoding.x.field === label) {
        this.fieldInUpdate.axis = this.vizOptions.axis[1]
      }
      if (this.storeState.analysis.viz.encoding.y.field === label) {
        this.fieldInUpdate.axis = this.vizOptions.axis[2]
      }
      if (!this.fieldInUpdate.axis) this.fieldInUpdate.axis = this.vizOptions.axis[0]
    },
    updateMeasureNow(index, index3, measureName) {
      let model = this.storeState.dbt.models[index]
      let column = model.columns[index3]
      
      let measure = this.storeState.dbt.models[index].columns[index3].meta.measures[measureName]
      this.fieldInUpdate = measure
      this.fieldInUpdate.description = `${measure.type} of ${model.name}.${column.name}`
      // this.fieldInUpdate.column = column
      this.updatingField = true
      this.fieldInUpdate.index = index
      this.fieldInUpdate.index3 = index3
      this.fieldInUpdate.dimOrMeas = 'measure'
      let label = this.getMeasureLabel(measure)
      if (this.storeState.analysis.viz.encoding.x.field === label) {
        this.fieldInUpdate.axis = this.vizOptions.axis[1]
      }
      if (this.storeState.analysis.viz.encoding.y.field === label) {
        this.fieldInUpdate.axis = this.vizOptions.axis[2]
      }
      if (!this.fieldInUpdate.axis) this.fieldInUpdate.axis = this.vizOptions.axis[0]
    },
    flipVizType(type) {
      this.storeState.analysis.viz.type = type
      this.createViz({})
    },
    setupMousetrap() {
      var self = this
      Mousetrap.bind('4', function(e) { console.log('4'); });
      Mousetrap.bind('/', function(e) { 
        if (e && e.preventDefault) e.preventDefault()
        self.$refs.search.focus()
      });
      Mousetrap.bind('esc', function(e) { 
        if (e && e.preventDefault) e.preventDefault()
        self.$refs.search.blur()
        self.searching = false
        self.updatingField = false
        self.searchTerm = ''
      });
      Mousetrap.bind('command+enter', function(e) { 
        if (e && e.preventDefault) e.preventDefault()
        self.runAnalysis()
      });
    },
    closeSearch() {
      this.$refs.search.blur()
      this.searching = false
      this.searchTerm = ''
    },
    generateDemoTable() {
      new Grid({
        sort: true,
        // search: true,
        columns: ["Name", "Email", "Phone Number"],
        data: [
          ["John", "john@example.com", "(353) 01 222 3333"],
          ["Mark", "mark@gmail.com", "(01) 22 888 4444"],
          ["Eoin", "eoin@gmail.com", "0097 22 654 00033"],
          ["Sarah", "sarahcdd@gmail.com", "+322 876 1233"],
          ["Afshin", "afshin@mail.com", "(353) 22 87 8356"]
        ],
        className: {
          td: 'px-6 py-4 whitespace-nowrap text-sm text-gray-100 divide-y divide-gray-200',
          th: 'px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider',
          table: 'min-w-full divide-gray-200',
          tbody: 'bg-white '
        }
      }).render(document.getElementById("testtable"));
    },
    createGrid(data) {
      console.log('createGrid...')
  //     columns: [
  //     { 
  //       name: 'Name',
  //       formatter: (cell) => `Name: ${cell}`
  //     },
  //     'Email',
  //  ],
      let columns = []
      for (let index = 0; index < data.cols.length; index++) {
        const col = data.cols[index];
        if (col.format) col.formatter = (cell) => `${SSF.format(col.format, cell)}`
        // col.formatter = (cell) => `${col.format}: ${cell}`
        columns.push(col)
      }
      window.analyzeGrid.updateConfig({
      // lets update the columns field only
        data: data.rows,
        columns: columns
      })
      if (window.analyzeGrid.config.container) {
        window.analyzeGrid.forceRender()
      } else {
        window.analyzeGrid.render(document.getElementById("gridInner"));
      }
      // document.getElementById("customerTable").innerHTML = ''
    },
    getApiUrl(endpoint) {
      if (process.env.NODE_ENV != 'production') return `http://127.0.0.1:5000/${endpoint}`
      return `https://pulse-backend.onrender.com/${endpoint}`
    },
    getAppUrl(endpoint) {
      if (process.env.NODE_ENV != 'production') return `http://localhost:8080/${endpoint}`
      return `https://trypaper.io/${endpoint}`
    },
    getFieldLabel(fieldInUpdate) {
      if (fieldInUpdate.dimOrMeas === 'measure') {
        return fieldInUpdate.label
      }
      return this.getDimensionLabel(fieldInUpdate)
    },
    getDimensionLabel(column) {
      if (column.meta && column.meta.dimension && column.meta.dimension.label) {
        return column.meta.dimension.label
      }
      return column.name
    },
    getMeasureLabel(column, columnName) {
      if (column && column.label) {
        return column.label
      }
      return columnName
    },
    getSelected(column) {
      if (column.meta && column.meta.dimension && column.meta.dimension.label) {
        return column.meta.dimension.label
      }
      if (column.meta && column.meta.measure && column.meta.measure.label) {
        return column.meta.measure.label
      }
      return column.name
    },
    getDbt() {
      this.gotDbt = false
      const path = this.getApiUrl('get_dbt')
      let d = {user: this.storeState.user, userData: this.storeState.userData}
      axios.post(path, d)
        .then((res) => {
          console.log('got get_dbt: ', res.data)
          this.gotDbt = true
          this.storeState.dbt = res.data.data
          // this.metricData = reactive(res.data)
          // this.createCharts()
          // this.createCustomerTable()
        })
        .catch((error) => {
          console.error(error)
        })
    },
    cancelRun() {
      this.running = false
      this.searching = false
    },
    showMsg(self, opts) {
      self.storeState.msg.show = true
      self.storeState.msg.primary = opts.primary
      self.storeState.msg.secondary = opts.secondary
      self.storeState.msg.type = opts.type
      setTimeout(() => self.storeState.msg.show = false, self.storeState.msg.time);
    },
    async updateSettings() {
      console.log('updateSettings...')
      if (!this.storeState.settings) return
      let updatedOn = new Date().toISOString();
      var result = null
      if (this.storeState.settings.fromSupa) {
        result = await supabase
        .from('profiles')
        .update({
          user_id: this.storeState.user.id,
          details: this.storeState.settings,
          updated_on: updatedOn,
        })
      } else {
        this.storeState.settings.fromSupa = true
        result = await supabase
        .from('profiles')
        .insert({
          user_id: this.storeState.user.id,
          details: this.storeState.settings,
        })
      }
      if (result.error) {
        console.error('updateCard error', result)
        if (result.error.message === 'JWT expired') {
          this.$router.push({ name: 'Login' })
        }
        return
      }
    },
  },
  watch: {
    'storeState.settings.notifications': {
        handler: function () {
          if (this.storeState.user && this.storeState.user.id) this.updateSettings()
        },
        deep: true
    },
    // 'storeState.settings.sheets': {
    //     handler: function () {
    //       if (this.storeState.gotUserData) this.updateSettings()
    //     },
    //     deep: true
    // },
  },
}
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable vue/no-unused-components */

</script>